import { Price as PriceUI } from '@youhelp-ru/ui';
import React from 'react';
import { formatNumber } from '../lib';

const formatRUFloat = Intl.NumberFormat('ru-ru', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
const formatRUInt = Intl.NumberFormat('ru-ru', { maximumFractionDigits: 0 });

export const Price: React.FC<{ value?: string | number | null; currency?: string; integer?: boolean }> = ({
  value,
  currency,
  integer,
}) => {
  switch (typeof value) {
    case 'number':
      return (
        <PriceUI
          currency={currency}
          numberFormat={integer ? formatRUInt : formatRUFloat}
          value={integer ? Math.trunc(value) : value}
        />
      );
    default:
      return <span>{formatNumber(value)}</span>;
  }
};
